import React, { useState, useEffect } from 'react'
import IsecNavbar2 from './IsecNavbar2';
import ClientNavbar1 from '../../Client-components/Pages/ClientNavbar1';
import IsecNavbar from './IsecNavbar';
import { useAuth } from '../../Context/UserContext';
import { useParams, useNavigate } from 'react-router-dom';
import { url } from '../../constants/url';
import ViewVulnerabilitiesAttachment from '../../Client-components/Modal/ViewVulnerabilityAttachment';

function IsecViewVulnerabilities() {
    const { isSidebarCollapsed, logout, userRole, emailVer, userPermission } = useAuth();
    const { id } = useParams();
    const navigate = useNavigate();

    const [allVulnerabilityData, setAllVulnerabilityData] = useState([])
    const [selectedVulId, setSelectedVulId] = useState(null);
    const [vulnerabilityData, setVulnerabilityData] = useState('')
    const [applicationType, setApplicationType] = useState('')
    const [pocImages, setPocImages] = useState([]);
    const [projectId, setProjectId] = useState('')
    const [remidiationPoc, setremidiationPoc] = useState([])
    const [viewPocIndex, setViewPocIndex] = useState(null);

    const normalizedAppType = String(applicationType ?? '')
        .trim()
        .toUpperCase();

    const allowedAppTypes = [
        'WEB',
        'API',
        'ANDROID',
        'ANDROID & IOS',
        'IOS'
    ];

    const formatDate = (dateString) => {
        const options = { day: "2-digit", month: "2-digit", year: "numeric" };
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", options);
    };

    const handleVulClick = (vulId) => {
        navigate(`/isecurion/viewvulnerabilities/${vulId}`);
        fetchVulnerabilityData(vulId)
        fetchPOCImages(vulId)
    };

    const fetchVulnerabilityData = async (vulId = id) => {
        setSelectedVulId(vulId);
        try {
            const response = await fetch(`${url}/viewvulnerabilitydataforisecurion?id=${vulId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            });

            const data = await response.json();
            setVulnerabilityData(data.vulnerabilityDetails);
            setApplicationType(data.projectData.applicationType)
            setProjectId(data.projectData._id)
            if (response.status === 403) {
                logout()
                return
            }

        } catch (error) {
            console.log('Error fetching vulnerability:', error);
        }
    };


    const fetchAllVulnerabilityData = async () => {
        try {
            const response = await fetch(`${url}/allclientvulnerabilityforisecurion?id=${id}`, {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                }
            })
            const data = await response.json()
            setAllVulnerabilityData(data)
        } catch (error) {
            console.log('Error fetching vulnerability:', error);
        }
    }

    const fetchPOCImages = async (vulId = id) => {
        try {
            const response = await fetch(`${url}/fetchpocforisecurion?vulnerabilityId=${vulId}`, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include'
            });

            if (response.status === 440) {
                return navigate('/');
            }

            const fetchedFiles = await response.json();

            // Now fetch each file as a blob and convert to object URL
            const imageBlobs = await Promise.all(
                fetchedFiles.map(async file => {
                    try {
                        const imageResponse = await fetch(file.url, {
                            method: 'GET',
                            credentials: 'include'
                        });

                        const blob = await imageResponse.blob();
                        const objectUrl = URL.createObjectURL(blob);

                        return {
                            fileName: file.fileName,
                            objectUrl, // Use this in <img src={objectUrl} />
                            lastModified: file.lastModified,
                            size: file.size,
                            pocFolder: file.pocFolder,
                        };
                    } catch (err) {
                        console.error(`Failed to fetch image blob for ${file.fileName}`, err);
                        return null;
                    }
                })
            );

            // Filter out any failed blob fetches
            const validImages = imageBlobs.filter(img => img !== null);

            setPocImages(validImages);
            console.log(validImages);

        } catch (error) {
            console.error("Error fetching PoC images:", error);
        }
    };

    const fetchPoc = async (vulId) => {
        try {
            const response = await fetch(`${url}/fetch-remediation-poc?vulnerabilityId=${vulId}`,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: "include"
                }
            )

            if (response.status === 440) {
                return navigate('/');
            }

            const fetchedFiles = await response.json();


            // Now fetch each file as a blob and convert to object URL
            const imageBlobs = await Promise.all(
                fetchedFiles.map(async file => {
                    try {
                        const imageResponse = await fetch(file.url, {
                            method: 'GET',
                            credentials: 'include'
                        });

                        const blob = await imageResponse.blob();
                        const objectUrl = URL.createObjectURL(blob);

                        return {
                            fileName: file.fileName,
                            objectUrl,
                            lastModified: file.lastModified,
                            size: file.size,
                            pocFolder: file.pocFolder,
                            filePath: file.filePath,
                        };
                    } catch (err) {
                        return null;
                    }
                })
            );


            const validImages = imageBlobs.filter(img => img !== null);

            setremidiationPoc(validImages);
        }
        catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        if (id) {
            fetchVulnerabilityData(id);
        }
        fetchAllVulnerabilityData()
        fetchPOCImages()
    }, [])

    useEffect(() => {
        if (!id) return;
        setremidiationPoc([]);
        fetchPoc(id);

    }, [id]);


    return (
        <div className='wrap_developer_page'>
            <div>
                <div className='client_navabr1'>
                    <ClientNavbar1 />
                </div>
                <div className='isecurion_navbar_second'><IsecNavbar2 projectid={projectId} /></div>
            </div>

            <div className='wrap_dev_content'>
                <div className={isSidebarCollapsed ? 'isecuriondash-navbar' : 'isecuriondash_close_navbar'}>
                    <IsecNavbar />
                </div>
                <div className='view_vulnerabilities_container'>
                    <div className='view_vulnerabilities_main_content'>
                        <div className='view_vulnerabilities_sidebar'>
                            {Array.isArray(allVulnerabilityData) &&
                                [...allVulnerabilityData]
                                    .sort((a, b) => {
                                        const order = ["critical", "high", "medium", "low", "info"];
                                        return (
                                            order.indexOf(a.severity.toLowerCase()) -
                                            order.indexOf(b.severity.toLowerCase())
                                        );
                                    })
                                    .map((vul, index) => (
                                        <div
                                            className={`view_vulnerabilities_sidebar_list ${selectedVulId === vul._id ? "selected" : ""
                                                }`}
                                            key={index}
                                            onClick={() => {
                                                setSelectedVulId(vul._id);
                                                handleVulClick(vul._id);
                                            }}
                                        >
                                            <p>{vul.vulnerabilityName}</p>
                                        </div>
                                    ))}
                        </div>

                        <div className='view_vulnerabilities_main_content_2'>

                            <div className='view_vulnerabilities_main_content_2_name'>
                                <div className='view_vulnerabilities_name'>
                                    <p>{vulnerabilityData?.vulnerabilityName}</p>
                                </div>
                                {/* <div className='view_vulnerabilities_status'>
                                                            <p>Status</p>
                                                            <div className='view_vulnerabilities_status_value'>
                        
                                                                {userPermission === 'level 4' && vulnerabilityData?.bugStatus === 'Open' ? (
                                                                    <div className='view_vul_accept'>
                                                                        <button onClick={() => handleAcceptVulnerability(vulnerabilityData?._id)}>Accept</button>
                                                                    </div>
                                                                ) : (
                                                                    !openAssignDropdown ? (
                                                                        <>
                                                                            <p className={getStatus(vulnerabilityData?.bugStatus)} style={{ fontWeight: 500 }}>{vulnerabilityData?.bugStatus}</p>
                                                                            <div className='edit_icon' onClick={(e) => {
                                                                                setOpenAssignDropdown(true)
                                                                            }}>
                                                                                <Icon icon="flowbite:edit-outline" width="20" height="20" />
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <div className="custom-select-wrapper">
                                                                            <Dropdown
                                                                                options={options}
                                                                                setOpenAssignDropdown={setOpenAssignDropdown}
                                                                                id={id}
                                                                                fetchVulnerabilityData={fetchVulnerabilityData}
                                                                            />
                                                                        </div>
                                                                    )
                                                                )}
                        
                                                            </div>
                                                        </div> */}
                            </div>
                            <div className='view_vulnerabilities_main_content_2_description'>
                                <h2>Description</h2>
                                <p>{vulnerabilityData?.description}</p>
                            </div>

                            <div className="view_vulnerabilities_main_content_2_information">
                                <h2 className="vuln-info-title">Vulnerability Information</h2>
                                <div className="vuln-info-table">
                                    <div className="vuln-info-row">
                                        <div className="vuln-info-label">Vulnerability Severity</div>
                                        <div className={`vuln-info-value vul-status-${vulnerabilityData?.severity?.toLowerCase().replace(/\s/g, '')}`}>{vulnerabilityData?.severity}</div>
                                    </div>
                                    <div className="vuln-info-row">
                                        <div className="vuln-info-label">CVE ID</div>
                                        <div className="vuln-info-value">{vulnerabilityData?.cveId}</div>
                                    </div>
                                    {console.log('Application Type:', applicationType)}
                                    {allowedAppTypes.includes(normalizedAppType) && (
                                        <div className="vuln-info-row">
                                            <div className="vuln-info-label">OWASP Category</div>
                                            <div className="vuln-info-value">
                                                {vulnerabilityData?.OWASP || 'Not Applicable'}
                                            </div>
                                        </div>
                                    )}

                                    <div className="vuln-info-row">
                                        <div className="vuln-info-label">Assigned To</div>
                                        <div className="vuln-info-value">
                                            <span className="vuln-info-avatar">{vulnerabilityData?.developerName ? vulnerabilityData?.developerName.charAt(0).toUpperCase() : 'U'}</span>  {!vulnerabilityData?.developerName ? 'Unassigned' : vulnerabilityData?.developerName}
                                        </div>
                                    </div>
                                    {applicationType !== 'WEB' && applicationType !== 'API' && applicationType !== 'ANDROID' && applicationType !== 'ANDROID & IOS' && applicationType !== 'IOS' && applicationType !== 'Source Code Review' ? '' : (
                                        <div className="vuln-info-row">
                                            <div className="vuln-info-label">CVSS String</div>
                                            <div className="vuln-info-value">{vulnerabilityData?.cvssString === '' ? 'NA' : vulnerabilityData?.cvssString}</div>
                                        </div>
                                    )}

                                    {applicationType !== 'WEB' && applicationType !== 'API' && applicationType !== 'ANDROID' && applicationType !== 'ANDROID & IOS' && applicationType !== 'IOS' && applicationType !== 'Source Code Review' ? '' : (
                                        <div className="vuln-info-row">
                                            <div className="vuln-info-label">CVSS Score</div>
                                            <div className="vuln-info-value">{vulnerabilityData?.cvssScore === '' ? 'NA' : vulnerabilityData?.cvssScore}</div>
                                        </div>
                                    )}

                                    {applicationType !== 'WEB' && applicationType !== 'API' && applicationType !== 'ANDROID' && applicationType !== 'ANDROID & IOS' && applicationType !== 'IOS' && applicationType !== 'Source Code Review' ? '' : (
                                        <div className="vuln-info-row">
                                            <div className="vuln-info-label">Ease of Exploitation</div>
                                            <div className="vuln-info-value">{vulnerabilityData?.exploitation === '' ? 'NA' : vulnerabilityData?.cvssScore}</div>
                                        </div>
                                    )}

                                    <div className="vuln-info-row">
                                        <div className="vuln-info-label">Upload Date</div>
                                        <div className="vuln-info-value">{formatDate(vulnerabilityData?.discovered)}</div>
                                    </div>
                                    <div className="vuln-info-row">
                                        <div className="vuln-info-label comments">Comments</div>
                                        <div className="vuln-info-value">
                                            {vulnerabilityData?.comments ? vulnerabilityData?.comments : '-'}
                                        </div>
                                    </div>
                                    <div className="vuln-info-row">
                                        <div className="vuln-info-label comments">Remediated  POC</div>
                                        <div className="vuln-info-value" style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '15px',
                                            alignItems: 'flex-start',
                                            marginTop: '20px',
                                            width: '100%'
                                        }}>
                                            {remidiationPoc.map((poc, index) => (
                                                < div key={index} onClick={() => setViewPocIndex(index)}>
                                                    <img
                                                        src={poc.objectUrl}
                                                        alt={`Remediation POC ${index + 1}`}
                                                        style={{
                                                            width: '200px',
                                                            height: '120px',
                                                            objectFit: 'cover',
                                                            borderRadius: '4px',
                                                            marginBottom: '10px'
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                            {viewPocIndex !== null && (
                                                <div
                                                    style={{
                                                        position: 'fixed',
                                                        inset: 0,
                                                        background: 'rgba(0, 0, 0, 0.85)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        zIndex: 9999
                                                    }}
                                                >
                                                    <img
                                                        src={remidiationPoc[viewPocIndex].objectUrl}
                                                        alt="POC Preview"
                                                        onClick={(e) => e.stopPropagation()}
                                                        style={{
                                                            width: '50%',
                                                            height: '50%',
                                                            objectFit: 'contain',
                                                            borderRadius: '6px'
                                                        }}
                                                    />

                                                    {/* Close */}
                                                    <button
                                                        type="button"
                                                        onClick={() => setViewPocIndex(null)}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '20px',
                                                            right: '25px',
                                                            fontSize: '30px',
                                                            color: '#fff',
                                                            background: 'transparent',
                                                            border: 'none',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        ×
                                                    </button>

                                                    {/* Previous */}
                                                    {remidiationPoc.length > 1 && (
                                                        <button
                                                            type="button"
                                                            onClick={(e) => {
                                                                setViewPocIndex((prev) =>
                                                                    prev === remidiationPoc.length - 1
                                                                        ? 0
                                                                        : prev + 1
                                                                );
                                                            }}

                                                            style={{
                                                                position: 'absolute',
                                                                left: '30px',
                                                                top: '50%',
                                                                fontSize: '50px',
                                                                color: '#fff',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            ‹
                                                        </button>
                                                    )}

                                                    {/* Next */}
                                                    {remidiationPoc.length > 1 && (
                                                        <button
                                                            type="button"
                                                            onClick={(e) => {
                                                                setViewPocIndex((prev) => prev === 0 ? remidiationPoc.length - 1 : prev - 1);
                                                            }}
                                                            style={{
                                                                position: 'absolute',
                                                                right: '30px',
                                                                top: '50%',
                                                                fontSize: '50px',
                                                                color: '#fff',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            ›
                                                        </button>
                                                    )}

                                                    {/* Counter */}
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            bottom: '25px',
                                                            color: '#fff',
                                                            fontSize: '14px'
                                                        }}
                                                    >
                                                        {viewPocIndex + 1} / {remidiationPoc.length}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {vulnerabilityData?.retestStatus ? (
                                        <div className="vuln-info-row">
                                            <div className="vuln-info-label">Retest Status</div>
                                            <div className="vuln-info-value">{vulnerabilityData?.retestStatus}</div>
                                        </div>
                                    ) : ''}

                                </div>
                            </div>

                            <div className='view_vulnerabilities_main_content_2_attachemnts'>
                                <ViewVulnerabilitiesAttachment
                                    vulnerabilityData={vulnerabilityData}
                                    setVulnerabilityData={setVulnerabilityData}
                                    setPocImages={setPocImages}
                                    pocImages={pocImages}
                                    applicationType={applicationType}

                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default IsecViewVulnerabilities